import { render, staticRenderFns } from "./toGuildLeader.vue?vue&type=template&id=9c76d5e6&scoped=true"
import script from "./toGuildLeader.vue?vue&type=script&lang=js"
export * from "./toGuildLeader.vue?vue&type=script&lang=js"
import style0 from "./toGuildLeader.vue?vue&type=style&index=0&id=9c76d5e6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c76d5e6",
  null
  
)

export default component.exports